export default {
  set(key, value) {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    return window.sessionStorage.getItem(key)
      ? JSON.parse(window.sessionStorage.getItem(key))
      : null;
  },
  remove(key) {
    window.sessionStorage.removeItem(key);
  },
  clear() {
    window.sessionStorage.clear();
  }
};
